window.addEventListener('DOMContentLoaded', () => {
  let buyBtn = document.querySelector('[data-buy-now]');
  buyBtn?.addEventListener('click', async (e) => {
    e.preventDefault();

    let variantOptions = e.currentTarget.closest('.pdp-content-wrapper').querySelectorAll('variant-selector .option-variant-wrapper');
    let allOptionSelected = true;
    variantOptions.forEach(variantOpt => {
      let selectedOpt = variantOpt.querySelector('input:checked');
      if (!selectedOpt) {
        allOptionSelected = false;
        let errorElement = variantOpt.querySelector('.error-message');
        errorElement.classList.remove('d-none');
        setTimeout(() => {
          errorElement.classList.add('d-none');
        }, 6000);
      }
    });
    if (allOptionSelected == false) {
      return false;  
    }

    e.target.classList.add('disabled')
    let form = e.currentTarget.closest('form');
    if (!e.target.getAttribute('show-cart')) {
      var cartClearFetch = await fetch(`/cart/clear.js`);
      var cartClear = await cartClearFetch.json(); 
    }
    
    let body = {
      id: form.querySelector('[name="id"]').value,
      quantity: form.querySelector('[name="quantity"]').value
    }

    let addProductFetch = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(body) } });
    let addProduct = await addProductFetch.json();
    if (addProduct) {
      if (e.target.getAttribute('show-cart')) {
        location.href = '/cart';
      } else {
        location.href = '/checkout';
      }
    }
  })

  const shareBtn = document.querySelectorAll('.share-product .share-text');
  shareBtn.forEach(item => {
    item.addEventListener('click', async (e) => {
      // const shareWrap = e.target.closest('.share-product');
      // if (shareWrap != null) {
      //   const shareTooltips = shareWrap.querySelector('.share-box');
      //   shareTooltips?.classList.toggle('d-none');
      // }
      var title = e.currentTarget.getAttribute('data-product-title');
      var prUrl = e.currentTarget.getAttribute('data-product-url');
        if(navigator) {
          await navigator.share({
              title: "Check this out!",
              text: title,
              url: prUrl
          })
        }
      
    })
  })
})